<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="报名编号" prop="signId" >
        <a-input v-model="form.signId" placeholder="请输入报名编号" />
      </a-form-model-item>
      <a-form-model-item label="用户编号" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户编号" />
      </a-form-model-item>
      <a-form-model-item label="赛事编号" prop="competitionId" >
        <a-input v-model="form.competitionId" placeholder="请输入赛事编号" />
      </a-form-model-item>
      <a-form-model-item label="模板编号" prop="templateId" >
        <a-input v-model="form.templateId" placeholder="请输入模板编号" />
      </a-form-model-item>
      <a-form-model-item label="证书编号" prop="cardNo" >
        <a-input v-model="form.cardNo" placeholder="请输入证书编号" />
      </a-form-model-item>
      <a-form-model-item label="获奖称号" prop="awardsName" >
        <a-input v-model="form.awardsName" placeholder="请输入获奖称号" />
      </a-form-model-item>
      <a-form-model-item label="赛事标题" prop="competitionTitle" >
        <a-input v-model="form.competitionTitle" placeholder="请输入赛事标题" />
      </a-form-model-item>
      <a-form-model-item label="模板图片" prop="templateImage" >
        <file-upload v-model="form.templateImage" type="image"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCompetitionSignCertificate, addCompetitionSignCertificate, updateCompetitionSignCertificate } from '@/api/platform/competitionSignCertificate'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        signId: null,

        userId: null,

        competitionId: null,

        templateId: null,

        cardNo: null,

        awardsName: null,

        competitionTitle: null,

        templateImage: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        signId: null,
        userId: null,
        competitionId: null,
        templateId: null,
        cardNo: null,
        awardsName: null,
        competitionTitle: null,
        templateImage: null,
        createTime: null,
        remark: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCompetitionSignCertificate({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCompetitionSignCertificate(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCompetitionSignCertificate(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
